/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
// import { DropdownArrowIcon } from '../../../../../images/icons/DropdownArrow/DropdownArrow'
// import OptionsItem from '../../Step05/components/OptionsItem'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
import { Alert } from '../../../../common/Alert/Alert'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 *     Step main container
 */
export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            values: this.props.values,
            dirty: false,
            errorList: [],
            showErrorOfCovar: false,
        }
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any, inputSec = false) => {
        if (this.props.dirty) {
            this.props.dirty(true)
        }

        if (inputSec && value !== '') {
            value = value.replace(/^-*/, '').replace(/^0+/, '')
        }

        this.setState({
            values: { ...this.state.values, [field]: value },
            dirty: true,
        })

        if (value && ((field === 'localExhibitions' && get(this.state, 'values.internationalExhibitions', 0) > 0) ||
            (field === 'internationalExhibitions' && get(this.state, 'values.localExhibitions', 0) > 0)) || (
                field === 'numberOfExhibitions' && (get(this.state, 'values.localExhibitions', 0) > 0) &&
                (get(this.state, 'values.internationalExhibitions', 0) > 0)
            )) {
            this.noOfExhibition(field === 'numberOfExhibitions' ? value < 2 ? 0 : value : 2)
        } else {
            if (field === 'localExhibitions' ||
                field === 'internationalExhibitions' || field === 'numberOfExhibitions') {
                this.noOfExhibition(field === 'numberOfExhibitions' ? value < 1 ? 0 : value : 1)
            }
        }
    }

    noOfExhibition = (val: any) => {
        setTimeout(() => { this.setState({ values: { ...this.state.values, ['numberOfExhibitions']: val } }) }, 0)
    }

    handleSubmit = (event: any) => {
        const {
            temporaryRemovalCoverValue,
            temporaryRemovalCover,
            // incomingExhibitionLimit,
            // outgoingExhibitionLimit,
            exhibitionCover,
            internationalExhibitions,
            numberOfExhibitions,
            limitPerExhibition,
            localExhibitions,
        } = this.state.values
        let changeAdj = true
        event.preventDefault()
        let errorList: any = []
        if (errorList.length !== 0) {
            this.setState({ errorList: errorList })
        } else {
            if (temporaryRemovalCover || exhibitionCover) {
                switch (true) {
                    // case (temporaryRemovalCover && (parseFloat(temporaryRemovalCoverValue) <
                    //     (parseFloat(incomingExhibitionLimit) + parseFloat(outgoingExhibitionLimit)))):
                    //     changeAdj = false
                    //     this.setState({ showErrorOfCovar: true })
                    //     break

                    case (temporaryRemovalCover &&
                        (!temporaryRemovalCoverValue || parseInt(temporaryRemovalCoverValue, 10) === 0)):
                        changeAdj = false
                        break

                    // case (temporaryRemovalCover &&
                    //     (!incomingExhibitionLimit || parseInt(incomingExhibitionLimit, 10) === 0)):
                    //     changeAdj = false
                    //     break

                    // case (temporaryRemovalCover &&
                    //     (!outgoingExhibitionLimit || parseInt(outgoingExhibitionLimit, 10) === 0)):
                    //     changeAdj = false
                    //     break

                    // case (exhibitionCover &&
                    //     (!internationalExhibitions || parseInt(internationalExhibitions, 10) === 0)):
                    //     changeAdj = false
                    //     break

                    case (exhibitionCover &&
                        (!numberOfExhibitions || parseInt(numberOfExhibitions, 10) === 0)):
                        changeAdj = false
                        break

                    case (exhibitionCover &&
                        (!limitPerExhibition || parseInt(limitPerExhibition, 10) === 0)):
                        changeAdj = false
                        break

                    case (exhibitionCover &&
                        ((Number(localExhibitions) + Number(internationalExhibitions)) === 0)):
                        changeAdj = false
                        break
                    default:
                        changeAdj = true
                }
            }

            if (changeAdj === true) {
                this.setState({ validateErr: false, showErrorOfCovar: false })
                this.props.handleAdjustChangeOptions(this.state.values)
                this.setState({ dirty: false, errorList: [] })
                if (this.props.dirty) {
                    this.props.dirty(false)
                }
            } else {
                this.setState({ validateErr: true })
            }
        }
    }

    render() {
        const {
            temporaryRemovalCover,
            exhibitionCover,
            temporaryRemovalCoverValue,
            // incomingExhibitionLimit,
            // outgoingExhibitionLimit,
            localExhibitions,
            internationalExhibitions,
            numberOfExhibitions,
            limitPerExhibition,
        } = this.state.values
        const { validateErr } = this.state
        let exceptionValidation = (Number(localExhibitions) + Number(internationalExhibitions)) === 0
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                     ${this.state.dirty ? 'plus57' : null}
                     ${(this.state.errorList.length) ? 'plus102' : null}`}
                >
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >
                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                        <OptionsCheckbox
                            id="temporaryRemovalCover"
                            title="Temporary Removal Cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.temporaryRemovalCover || false}
                            value={this.props.values.temporaryRemovalCover}
                            tooltipView={false}
                        />

                        <div className={`options__item item_group ${!(temporaryRemovalCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label>Cover Value *</label>
                                        <div
                                            className={`input 
                                        ${(temporaryRemovalCover &&
                                                    (!temporaryRemovalCoverValue ||
                                                        parseInt(temporaryRemovalCoverValue, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="temporaryRemovalCoverValue"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('temporaryRemovalCoverValue', v, true)
                                                }}
                                                value={temporaryRemovalCoverValue}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        {/* empty value */}
                                    </div>
                                </div>
                                {/* <div className="input_group_sec right">
                                    <div className="input_sec">
                                        <label>Incoming Exhibition Limit *</label>
                                        <div
                                            className={`input 
                                        ${(temporaryRemovalCover &&
                                            (!incomingExhibitionLimit || parseInt(incomingExhibitionLimit, 10) === 0)
                                                    && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="incomingExhibitionLimit"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('incomingExhibitionLimit', v, true)
                                                }}
                                                value={incomingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label>Outgoing Exhibition Limit *</label>
                                        <div
                                            className={`input 
                                        ${(temporaryRemovalCover &&
                                            (!outgoingExhibitionLimit || parseInt(outgoingExhibitionLimit, 10) === 0)
                                                    && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="outgoingExhibitionLimit"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('outgoingExhibitionLimit', v, true)
                                                }}
                                                value={outgoingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <OptionsCheckbox
                            id="exhibitionCover"
                            title="Exhibition / Fair cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.exhibitionCover || false}
                            value={this.props.values.exhibitionCover}
                            tooltipView={false}
                        />

                        <div className={`options__item item_group ${!(exhibitionCover) ? `hidden` : ``}`}>
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label className="variation_label">Total aggregate value of stock during the
                                            policy period at domestic Fairs or exhibitions *</label>
                                        <div
                                            className={`input 
                                        ${(exhibitionCover && exceptionValidation === true && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="localExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('localExhibitions', v, true)
                                                }}
                                                value={localExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label className="variation_label">Total aggregate value of stock during the
                                            policy period at international Fairs or exhibitions *</label>
                                        <div
                                            className={`input 
                                        ${(exhibitionCover && exceptionValidation === true && validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="internationalExhibitions"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('internationalExhibitions', v, true)
                                                }}
                                                value={internationalExhibitions}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="input_group_sec right">
                                    <div className="input_sec">
                                        <label className="variation_label">Total number of fairs or exhibitions planned
                                            during the policy period *</label>
                                        <div
                                            className={`input input__no-symbol 
                                        ${(exhibitionCover &&
                                                    (!numberOfExhibitions || parseInt(numberOfExhibitions, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <input
                                                name="numberOfExhibitions"
                                                placeholder="0"
                                                type="number"
                                                max={Number(localExhibitions) === 0 ||
                                                    Number(internationalExhibitions) === 0 ? '' : ''}
                                                min={exhibitionCover ? Number(localExhibitions) !== 0 &&
                                                    Number(internationalExhibitions) !== 0 ? '2' : '1' : '0'}
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('numberOfExhibitions', v, true)
                                                }}
                                                value={numberOfExhibitions}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label className="variation_label">Maximum sum insured per fair of exhibition *
                                        </label>
                                        <div
                                            className={`input 
                                        ${(exhibitionCover &&
                                                    (!limitPerExhibition || parseInt(limitPerExhibition, 10) === 0) &&
                                                    validateErr === true) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">{symbol()}</div>
                                            <input
                                                name="limitPerExhibition"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('limitPerExhibition', v, true)
                                                }}
                                                value={limitPerExhibition}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    {(this.state.showErrorOfCovar) ? (

                        <Alert type="error">
                            Error: Incoming/Outgoing Limit must not exceed Cover Value.
                        </Alert>

                    ) : null}
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/components/VariationOptions.tsx